import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

import { AgeGroupsEnum, IFilterForReports } from "../../../../components/Reports/common/interfaces";
import { RootState } from "../../../../app/store";
import { GenderEnum } from "../../../users/usersSlice";
import { ExtendedStatus } from "../../../../components/Reports/Company/StatusSelector";

const initialState: IFilterForReports = {
};

export const dataSlice = createSlice({
  name: "topicsReportsFilter",
  initialState,
  reducers: {
    setCampaignDateFrom(state, action: PayloadAction<moment.Moment | null>) {
      state.campaignDates = {
        ...state.campaignDates ?? {
          from: null,
          to: null,
        },
        from: action.payload,
      };
    },
    setCampaignDateTo(state, action: PayloadAction<moment.Moment | null>) {
      state.campaignDates = {
        ...state.campaignDates ?? {
          from: null,
          to: null,
        },
        to: action.payload,
      };
    },
    setCompanyEnabled(state, action: PayloadAction<ExtendedStatus>) {
      state.companyEnabled = action.payload;
    },
    setCompanyId(state, action: PayloadAction<string>) {
      console.log("🚀 ~ action.payload:", action.payload)
      state.companyId = action.payload;
    },
    setGroupId(state, action: PayloadAction<string>) {
      state.groupId = action.payload;
    },
    setInOutFromCompanyDateFrom(state, action: PayloadAction<moment.Moment | null>) {
      state.inOutFromCompanyDates = {
        ...state.inOutFromCompanyDates ?? {
          from: null,
          to: null,
        },
        from: action.payload,
      };
    },
    setInOutFromCompanyDateTo(state, action: PayloadAction<moment.Moment | null>) {
      state.inOutFromCompanyDates = {
        ...state.inOutFromCompanyDates ?? {
          from: null,
          to: null,
        },
        to: action.payload,
      };
    },
    setInOutFromCompanyAccumulatedDateFrom(state, action: PayloadAction<moment.Moment | null>) {
      state.inOutFromCompanyAccumulatedDates = {
        ...state.inOutFromCompanyAccumulatedDates ?? {
          from: null,
          to: null,
        },
        from: action.payload,
      };
    },
    setInOutFromCompanyAccumulatedDateTo(state, action: PayloadAction<moment.Moment | null>) {
      state.inOutFromCompanyAccumulatedDates = {
        ...state.inOutFromCompanyAccumulatedDates ?? {
          from: null,
          to: null,
        },
        to: action.payload,
      };
    },
    setUsersGender(state, action: PayloadAction<GenderEnum|undefined>) {
      state.usersGender = action.payload;
    },
    setUsersAge(state, action: PayloadAction<AgeGroupsEnum|undefined>) {
      state.usersAge = action.payload;
    },
  },
});

export const {
  setCampaignDateFrom: setCampaignDateFromForTopicsReports,
  setCampaignDateTo: setCampaignDateToForTopicsReports,
  setCompanyEnabled: setCompanyEnabledForTopicsReports,
  setCompanyId: setCompanyIdForTopicsReports,
  setGroupId: setGroupIdForTopicsReports,
  setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForTopicsReports,
  setInOutFromCompanyDateTo: setInOutFromCompanyDateToForTopicsReports,
  setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForTopicsReports,
  setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForTopicsReports,
  setUsersGender: setUsersGenderForTopicsReports,
  setUsersAge: setUsersAgeForTopicsReports,
} = dataSlice.actions;


export const selectTopicsReportsFilter = (state: RootState) => {
  return state.reports.learning.topics.filter;
}

export default dataSlice.reducer;